import type { CanMatchFn } from '@angular/router';

import { inject } from '@angular/core';
import { NewUserJourneyAbTestVariantEnum } from '@models/ab-test-models';
import { Store } from '@ngrx/store';
import { getNewUserJourneyAbTestVersion } from '@stores/abtest/abtest-ngrx.selector';
import { filter, map } from 'rxjs';

export const notLegacyJourneyGuard: CanMatchFn = () => {
  return inject(Store)
    .select(getNewUserJourneyAbTestVersion)
    .pipe(
      filter((variant) => !!variant),
      map(
        (variant) =>
          variant === NewUserJourneyAbTestVariantEnum.Orders ||
          variant === NewUserJourneyAbTestVariantEnum.ContinuousImprovement
      )
    );
};

export const legacyJourneyGuard: CanMatchFn = () => {
  return inject(Store)
    .select(getNewUserJourneyAbTestVersion)
    .pipe(
      filter((variant) => !!variant),
      map((variant) => variant === NewUserJourneyAbTestVariantEnum.Legacy)
    );
};
